import React from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <motion.h1
              className="hero-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              YKS Hazırlık Sürecinde<br />
              <span className="gradient-text">En Güçlü Yardımcınız</span>
            </motion.h1>
            <motion.p
              className="hero-description"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              Asistan destekli analizler, akıllı tekrar sistemi ve tamamen offline kullanım ile rakiplerinizin bir adım önüne geçin.
            </motion.p>
            <motion.div
              className="hero-buttons"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <motion.a
                href="https://play.google.com/store/apps/details?id=com.soruly.app"
                // bu kısmı sonradan değiştireceğiz !!!!!!!!!!
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Google Play'den İndir
              </motion.a>

              <motion.a
                href="https://play.google.com/store/apps/details?id=com.soruly.app"
                // bu kısmı sonradan değiştireceğiz !!!!!!!!!!
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                App Store'dan İndir
              </motion.a>

            </motion.div>
            <motion.div
              className="hero-stats"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <div className="stat-item">
                <span className="stat-value">100%</span>
                <span className="stat-label">Offline</span>
              </div>
              <div className="stat-item">
                <span className="stat-value">Ücretsiz</span>
                <span className="stat-label">Reklamsız</span>

              </div>
            </motion.div>
          </div>
          <motion.div
            className="hero-image"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {/* Placeholder for App Screenshot */}
            <motion.div
              className="phone-frame"
              animate={{ y: [0, -20, 0] }}
              transition={{
                duration: 6,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            >
              <div className="phone-screen">
                <img
                  src="/images/hero-app-screen.jpeg"
                  alt="Uygulama Önizleme"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
